import type { ChangeEvent } from "react";
import TextField from "@mui/material/TextField";
import { getFormInputProps } from "util/forms";
import { FormField } from "../../types";
import type { StringValue, SetupValueProps } from "../types";

const String = ({
    values,
    handleBlur,
    onChange,
    ...restProps
}: SetupValueProps<StringValue>) => (
    <TextField
        {...getFormInputProps(FormField.SetupValue, restProps)}
        fullWidth
        size='small'
        name={FormField.SetupValue}
        value={values[FormField.SetupValue].value}
        label='String Setup Value'
        onBlur={handleBlur}
        onChange={({ target }: ChangeEvent<HTMLInputElement>) => onChange!(target.value)}
    />
);

export default String;
